import React from 'react';
import { CtaBlock } from '../CtaButton';
import { Accent } from './SectionHeading';
import { AssuranceRow } from './AssuranceRow';
import { MOCKUP_URL } from '../../data/images';
export function HeroSection() {
  return <section className="bg-brand-paper px-5 pb-16 pt-10 lg:px-8 lg:pb-20 lg:pt-14" data-id="element-84" data-mp="16okwuzd879zg">
      <div className="mx-auto max-w-4xl text-center" data-id="element-85" data-mp="12mr37b1g768s">
        <h1 className="font-display text-[2.6rem] font-bold leading-[1.02] tracking-[-0.015em] text-brand-charcoal sm:text-[3.4rem] lg:text-[4.25rem]" data-id="element-86" data-mp="12k4uv96qgmpi">
          Nageldesign-Trainerin? Schluss mit stundenlanger Unterrichtsvorbereitung!
        </h1>

        <p className="mx-auto mt-5 max-w-2xl font-display text-[1.6rem] leading-snug sm:text-[2rem]" data-id="element-87" data-mp="1qahcxcvozztt">
          <Accent data-id="element-88" data-mp="1lbe7vsfpptlu">Mehr Struktur. Weniger Vorbereitungsaufwand.</Accent>
        </p>
      </div>

      <img src={MOCKUP_URL} alt="Nail Educator Ready — Deutsche Ausgabe: die 6 Fachbände und Innenseiten auf Tablet, Laptop und Smartphone" width={1536} height={1024} loading="eager" decoding="async" className="mx-auto mt-10 block w-full max-w-[640px] object-contain lg:max-w-[900px]" style={{
      filter: 'drop-shadow(0 34px 40px rgba(78, 49, 108, 0.22))'
    }} data-id="element-89" data-mp="exev6ehux482" />

      <p className="mx-auto mt-8 max-w-2xl text-center text-[15px] leading-relaxed text-brand-charcoal/75 sm:text-[16px]" data-id="element-90" data-mp="2zfdbe36huwk8">
        Du möchtest professionelle Nageldesign-Schulungen anbieten, aber die Vorbereitung kostet dich zu viel Zeit?
        Mit <strong className="font-semibold text-brand-charcoal" data-id="element-91" data-mp="2uga7im292wdu">NAIL EDUCATOR READY™</strong> erhältst du sechs
        digitale Fachbände mit verständlich aufbereitetem Fachwissen, visuellen Anleitungen, praktischen Übungen und
        Materialien für einen strukturierteren Unterricht.
      </p>

      <CtaBlock label="Jetzt alle 6 Bände sichern" className="mt-8" data-id="element-92" data-mp="26r94xfg3mfgh" />
      <AssuranceRow className="mt-5" data-id="element-93" data-mp="26t2ccwyjd3pj" />
    </section>;
}